import { useSelector } from "react-redux";
import { RootState } from "../store/store";

export default function ProfilePicture({
  file,
  className,
}: {
  file: File | null;
  className?: string;
}) {
  const user = useSelector((s: RootState) => s.appAuthReducer.user);
  const seed = user?.name || "anon";
  const img = file
    ? URL.createObjectURL(file)
    : `https://api.dicebear.com/9.x/initials/svg?radius=50&fontWeight=600&backgroundColor=f97316&seed=${encodeURIComponent(
        seed,
      )}`;
  return <img src={img} alt="user avatar" className={className} />;
}
